import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'jhi-bary-specific-button',
  templateUrl: './bary-specific-button.component.html',
  styleUrls: ['./bary-specific-button.component.scss'],
})
export class BarySpecificButtonComponent {
  @Input() type: string | undefined;
  @Input() size = 'lg';
  @Input() tooltip?: string;
  @Output() clickEvent = new EventEmitter<MouseEvent>();

  handleClick($event: MouseEvent): void {
    this.clickEvent.emit($event);
  }
}
